import { CreateProjectModel } from '../model/projectModel';
import { CreateProjectPayloadModel } from '../model/projectPayloadModel';

export const createProjectDataToPayload = (projectData: CreateProjectModel): CreateProjectPayloadModel => {
  const { clientId, name, supportEmail, type, usersRequireVerification, usersVerifiers } = projectData;

  return {
    client_id: clientId,
    name,
    support_email: supportEmail,
    type,
    users_require_verification: usersRequireVerification,
    users_verifiers: usersVerifiers,
  };
};
